/* eslint-disable import/prefer-default-export */

// import ms from 'ms';

import React from 'react';
import styled from 'styled-components';
import isArray from 'lodash/isArray';
import moment from 'moment-timezone';

import Admin from 'hive-admin';
import FieldRadio from 'hive-admin/src/components/FieldRadio';

import AntdRadio from 'antd/lib/radio';
// import AntdTag from 'antd/lib/tag';
import {
  parse as parseQuery,
  // eslint-disable-next-line import/no-extraneous-dependencies
} from 'query-string';

import { renderCurrency } from '../../components/SystemCountry';

import getFilterWithCol from '../../helpers/getFilterWithCol';
import clickAnchor from '../../helpers/clickAnchor';

import {
  filterShippingCompanyImport,
} from './filterShippingCompanyImport';

import tests from '../../helpers/tests';

import Types from '../../modules/types';

const viewerIsNotAdmin = Admin.compileFromLibrary(tests.viewerIsNotAdmin);

const {
  CONSTANTS: {
    OrderStatus,
    ShippingStorage,
    // ShippingProvider,
  },
} = Types;

const RadioComponent = styled(FieldRadio.config.Component)`
  display: flex;
  width: 100%;
  > .ant-radio-button-wrapper {
    flex: 1;
    flex-shrink: 1;
    align-items: center;
    justify-content: center;
    text-align: center;
    height: auto;
    line-height: 100%;
    display: flex;
    padding: 8px 5px;
    white-space: nowrap;
  }
`;

// const DiscountNameAndCode = ({ name, code }) => (
//   <span>
//     {name}
//     <span>&nbsp;/&nbsp;</span>
//     <AntdTag>
//       {code}
//     </AntdTag>
//   </span>
// );

const getValueForFieldDefault = value => (
  value && value.length
    ? value
    : undefined
);

// const filterTests = ['all', 'shipping', 'ids'].reduce(
//   (agr, value) => {
//     agr.is[value] = props => props.searchParams.filter === value;
//     agr.isNot[value] = props => props.searchParams.filter !== value;
//     return agr;
//   },
//   { is: {}, isNot: {} },
// );

export const scopeToListableOrders = ['FilterField', {
  id: 'scopeToOrdersForAdmin',
  section: 'bottom',
  buildQuery: (value, builder, filter, params, { pageProps }) => {
    const searchParams = pageProps?.searchParams || {};
    const selectedStatuses = searchParams.status;
    const invalidSelected = (
      selectedStatuses
      && (isArray(selectedStatuses) ? selectedStatuses : [selectedStatuses])
        .includes('INVALID')
    );

    // Exclude INVALID orders by default, unless INVALID is explicitly selected
    const statuses = invalidSelected
      ? Types.ORDER_STATUS_LISTABLE
      : Types.ORDER_STATUS_LISTABLE.filter(s => s !== 'INVALID');

    builder.add('where', {
      status: { IN: statuses },
    });
  },
  getValueForField: () => undefined,
  field: ['FieldText', {
    name: 'scopeToOrdersForAdmin',
    style: { display: 'none' },
  }],
}];

export const scopeToListableOrdersForSeller = ['FilterHidden', {
  id: 'scopeToOrdersForAdminSeller',
  section: 'bottom',
  build: builder => builder.add('where', {
    status: { IN: Types.ORDER_STATUS_LISTABLE_SELLER },
  }),
}];

export const scopeToPendingApprovalOrders = ['FilterHidden', {
  id: 'scopeToPendingApprovalOrders',
  section: 'bottom',
  build: builder => builder.add('where', {
    status: { EQ: OrderStatus.APPROVAL },
  }),
}];

export const scopeToShippingStorageNotWarehouseOrders = ['FilterHidden', {
  id: 'scopeToShippingStorageNotWarehouseOrders',
  section: 'bottom',
  build: builder => builder.add('where', {
    'shipping.storage': { NE: ShippingStorage.WAREHOUSE },
  }),
}];

export const pagination = ['FilterPagination', {
  id: 'pagination',
  section: 'bottom',
}];

export const populateStore = ['FilterHidden', {
  id: 'populate',
  build: builder => builder.add(
    'populate',
    {
      store: { name: true },
      'shipping.company': { name: true },
    },
  ),
}];

export const limitTo50 = ['FilterHidden', {
  id: 'limitTo50',
  build: builder => builder.add('limit', 50),
}];

export const filterType = ['FilterField', {
  id: 'filter',
  label: null,
  section: 'top',
  VALUES_MAP: {
    all: {},
    ids: { filter: 'ids' },
  },
  buildQuery: (value, builder, filter, params) => {
    if (value === 'ids' && !params.ids?.length) {
      builder.add('where', { _id: '........' });
    }
    builder.add(
      'custom',
      (
        filter.VALUES_MAP[value]
          ? { ...filter.VALUES_MAP[value] }
          : { ...filter.VALUES_MAP.all }
      ),
    );
  },
  getValueForField: getValueForFieldDefault,
  getValueForQuery: value => (value === 'all' ? undefined : value),
  field: ['FieldRadio', {
    name: 'filter',
    block: true,
    defaultValue: null,
    initialValue: null,
    prepareValueForInput: value => (value ? value : 'all'),
    choices: [{
      label: 'Use Filters',
      value: 'all',
    }, {
      label: 'Pick Manually',
      value: 'ids',
    }],
  }],
}];

export const filterIds = ['FilterField', {
  id: 'ids',
  label: null,
  section: 'top',
  propsFromPage: props => ({ client: props.client }),
  buildQuery: (value, builder) => value && value.length && builder.add(
    'where',
    { _id: { IN: isArray(value) ? value : [value] } },
  ),
  getValueForField: getValueForFieldDefault,
  field: ['FieldConnectionSelect', {
    name: 'ids',
    url: '/orders',
    placeholder: 'Orders',
    mode: 'multiple',
    allowClear: true,
    searchPaths: ['_id'],
    extraQuerySortProps: { createdAt: -1 },
  }],
}];

export const filterId = ['FilterField', {
  id: 'id',
  label: null, // 'ID',
  section: 'top',
  buildQuery: (value, builder) => value && builder.add(
    'where',
    {
      OR: [
        { _id: { REGEX: value, OPTIONS: 'i' } },
        { 'shippingDetails.name': { REGEX: value, OPTIONS: 'i' } },
        { 'shippingDetails.email': { REGEX: value, OPTIONS: 'i' } },
        // eslint-disable-next-line max-len
        { 'shippingDetails.phoneNumber.number': { REGEX: value, OPTIONS: 'i' } },
      ],
    },
  ),
  getValueForField: value => value || '',
  getValueForQuery: (value) => {
    value = !value
      ? undefined
      : value.target
        ? value.target.value
        : value;
    return !value || !value.length
      ? undefined
      : value;
  },
  field: ['FieldText', {
    name: 'id',
    placeholder: 'Search',
  }],
}];

export const [
  filterStatus,
  filterStatusSeller,
] = [
  Types.ORDER_STATUS_LISTABLE,
  Types.ORDER_STATUS_LISTABLE_SELLER,
].map(validOrderStatuses => ['FilterField', {
  id: 'status',
  label: null,
  section: 'top',
  buildQuery: (value, builder) => {
    if (value && value.length) {
      value = isArray(value) ? value : [value];
      const conditions = [];
      for (let i = 0; i < value.length; i++) {
        const statusInput = value[i];
        if (statusInput) {
          const [status, modifier] = statusInput.split('-');
          if (status === 'NEW') {
            if (!modifier) {
              conditions.push({ status });
            } else if (modifier === 'READY') {
              conditions.push({
                status,
                'shipping.readyForPickup': { NE: false },
              });
            } else if (modifier === 'PREPARING') {
              conditions.push({
                status,
                'shipping.readyForPickup': false,
                'shipping.scheduled': { NE: true },
              });
            } else if (modifier === 'SCHEDULED') {
              conditions.push({
                status,
                'shipping.readyForPickup': false,
                'shipping.scheduled': true,
              });
            }
          } else {
            conditions.push({ status });
          }
        }
      }
      builder.add(
        'where',
        { OR: conditions },
      );
    }
  },
  getValueForField: getValueForFieldDefault,
  field: ['FieldSelect', {
    name: 'status',
    placeholder: 'Status',
    mode: 'multiple',
    allowClear: true,
    choices: (
      Types.ORDER_STATUS
        .filter(status => validOrderStatuses.includes(status))
        .reduce(
          (agr, status) => {
            const label = Types.ORDER_STATUS_LABELS_MAP[status];
            agr.push({
              label,
              value: status,
            });
            if (status === OrderStatus.NEW) {
              agr.push({
                label: `${label} / Ready`,
                value: 'NEW-READY',
              });
              agr.push({
                label: `${label} / Preparing`,
                value: 'NEW-PREPARING',
              });
              agr.push({
                label: `${label} / Scheduled`,
                value: 'NEW-SCHEDULED',
              });
            }
            return agr;
          },
          [],
        )
    ),
  }],
}]);

export const filterSort = ['FilterField', {
  id: 'sort',
  label: null,
  section: 'top',
  VALUES_MAP: {
    createdAsc: { createdAt: 1 },
    createdDesc: { createdAt: -1 },
    approvedAsc: { approvedAt: 1 },
    approvedDesc: { approvedAt: -1 },
    shippedAsc: { shippedAt: 1 },
    shippedDesc: { shippedAt: -1 },
    completedAsc: { completedAt: 1 },
    completedDesc: { completedAt: -1 },
    amountAsc: { 'cost.charged': 1, createdAt: -1 },
    amountDesc: { 'cost.charged': -1, createdAt: -1 },
    shippingAsc: { 'cost.shipping': 1, createdAt: -1 },
    shippingDesc: { 'cost.shipping': -1, createdAt: -1 },
  },
  buildQuery: (value, builder, filter) => (
    filter.VALUES_MAP[value]
      ? builder.add('sort', { ...filter.VALUES_MAP[value] })
      : builder.add('sort', { ...filter.VALUES_MAP.createdDesc })
  ),
  getValueForField: getValueForFieldDefault,
  field: ['FieldSelect', {
    name: 'sort',
    placeholder: 'Sort',
    defaultValue: 'createdDesc',
    initialValue: 'createdDesc',
    prepareValueForInput: value => (value ? value : 'createdDesc'),
    choices: [{
      label: '↓ Date Created',
      value: 'createdDesc',
    }, {
      label: '↑ Date Created',
      value: 'createdAsc',
    }, {
      label: '↓ Date Approved',
      value: 'approvedDesc',
    }, {
      label: '↑ Date Approved',
      value: 'approvedAsc',
    }, {
      label: '↓ Date Shipped',
      value: 'shippedDesc',
    }, {
      label: '↑ Date Shipped',
      value: 'shippedAsc',
    }, {
      label: '↓ Date Completed',
      value: 'completedDesc',
    }, {
      label: '↑ Date Completed',
      value: 'completedAsc',
    }, {
      label: '↓ Charged',
      value: 'amountDesc',
    }, {
      label: '↑ Charged',
      value: 'amountAsc',
    }, {
      label: '↓ Shipping cost',
      value: 'shippingDesc',
    }, {
      label: '↑ Shipping cost',
      value: 'shippingAsc',
    }],
  }],
}];
export const filterSortIds = ['FilterField', {
  id: 'sort-ids',
  label: null,
  section: 'top',
  VALUES_MAP: {
    created: { createdAt: -1 },
    approved: { approvedAt: -1 },
  },
  buildQuery: (value, builder, filter) => (
    filter.VALUES_MAP[value]
      ? builder.add('sort', { ...filter.VALUES_MAP[value] })
      : builder.add('sort', { ...filter.VALUES_MAP.created })
  ),
  getValueForField: getValueForFieldDefault,
  field: ['FieldSelect', {
    name: 'sort-ids',
    placeholder: 'Sort',
    defaultValue: 'created',
    initialValue: 'created',
    prepareValueForInput: value => (value ? value : 'created'),
    choices: [{
      label: 'Sort by date created',
      value: 'created',
    }, {
      label: 'Sort by date approved',
      value: 'approved',
    }],
  }],
}];

export const filterShipping = ['FilterField', {
  id: 'shipping',
  label: null,
  section: 'top',
  buildQuery: (value, builder, filter) => {
    if (value && value.length) {
      const isSideB = filter.id.indexOf('b.') === 0
      const whereKey = isSideB ? 'whereB' : 'where';
      builder.add(
        whereKey,
        { 'shipping.method': { IN: isArray(value) ? value : [value] } },
      );
    }
  },
  getValueForField: getValueForFieldDefault,
  field: ['FieldSelect', {
    name: 'shipping',
    placeholder: 'Shipping',
    mode: 'multiple',
    allowClear: true,
    choices: Types.SHIPPING_METHOD_USED.map(value => ({
      label: Types.SHIPPING_METHOD_LABELS_MAP[value],
      value,
    })),
  }],
}];

export const filterStorage = ['FilterField', {
  id: 'storage',
  label: null,
  section: 'top',
  buildQuery: (value, builder) => value && value.length && builder.add(
    'where',
    { 'shipping.storage': { IN: isArray(value) ? value : [value] } },
  ),
  getValueForField: getValueForFieldDefault,
  field: ['FieldSelect', {
    name: 'storage',
    placeholder: 'Storage',
    mode: 'multiple',
    allowClear: true,
    choices: Types.SHIPPING_STORAGE_ITEMS.map(({ labelShort, id }) => ({
      value: id,
      label: labelShort,
    })),
  }],
}];

export const filterStorageRadio = ['FilterField', {
  id: 'storageRadio',
  label: null,
  section: 'top',
  VALUES_MAP: {
    all: {},
    WAREHOUSE: { 'shipping.storage': ShippingStorage.WAREHOUSE },
  },
  buildQuery: (value, builder, filter) => value && value.length && builder.add(
    'where',
    filter.VALUES_MAP[value],
  ),
  getValueForField: getValueForFieldDefault,
  prepareValueForInput: value => (value ? value : 'all'),
  field: ['FieldRadio', {
    name: 'storageRadio',
    label: null,
    initialValue: '',
    block: true,
    choices: [{
      label: 'All',
      value: 'all',
    }, {
      label: 'Warehouse',
      value: 'WAREHOUSE',
    }],
  }],
}]

export const filterShippingCountry = ['FilterField', {
  id: 'shippingcountries',
  label: null,
  section: 'top',
  buildQuery: (value, builder) => value && value.length && builder.add(
    'where',
    {
      'shippingDetails.address.country': {
        IN: isArray(value) ? value : [value],
      },
    }),
  getValueForField: getValueForFieldDefault,
  field: ['FieldSelect', {
    name: 'shippingcountries',
    placeholder: 'Shipping Countries',
    mode: 'multiple',
    allowClear: true,
    choices: Types.COUNTRIES.map(({ iso3a2, name }) => ({
      label: name,
      value: iso3a2,
    })),
  }],
}];

export const filterPayment = ['FilterField', {
  id: 'payment',
  label: null,
  section: 'top',
  buildQuery: (value, builder, filter) => {
    if (value && value.length) {
      const isSideB = filter.id.indexOf('b.') === 0
      const whereKey = isSideB ? 'whereB' : 'where';
      builder.add(
        whereKey,
        { 'payment.method': { IN: isArray(value) ? value : [value] } },
      );
    }
  },
  getValueForField: getValueForFieldDefault,
  field: ['FieldSelect', {
    name: 'payment',
    placeholder: 'Payment',
    mode: 'multiple',
    allowClear: true,
    renderChoices: (field, props) => {
      const isSeller = props?.viewer?.role === 'SELLER';
      return Types.PAYMENT_METHOD_ITEMS.reduce(
        (agr, item) => {
          if (!item.deprecated || (isSeller && !item.sellerDeprecated)) {
            agr.push(props.renderChoice({
              label: item.label,
              value: item.id,
            }, field, props));
          }
          return agr;
        },
        [],
      );
    },
  }],
}];
export const filterProvider = ['FilterField', {
  id: 'provider',
  label: null,
  section: 'top',
  buildQuery: (value, builder, filter) => {
    if (value && value.length) {
      const isSideB = filter.id.indexOf('b.') === 0
      const whereKey = isSideB ? 'whereB' : 'where';
      builder.add(
        whereKey,
        { 'payment.provider': { IN: isArray(value) ? value : [value] } },
      );
    }
  },
  getValueForField: getValueForFieldDefault,
  field: ['FieldSelect', {
    name: 'provider',
    placeholder: 'Provider',
    mode: 'multiple',
    allowClear: true,
    renderChoices: (field, props) => {
      const isSeller = props?.viewer?.role === 'SELLER';
      return Types.PAYMENT_PROVIDER_ITEMS.reduce(
        (agr, item) => {
          if (!item.deprecated || (isSeller && !item.sellerDeprecated)) {
            agr.push(props.renderChoice({
              label: item.label,
              value: item.id,
            }, field, props));
          }
          return agr;
        },
        [],
      );
    },
  }],
}];

export const filterPaymentStatus = ['FilterField', {
  id: 'paymentstatus',
  label: null,
  section: 'top',
  buildQuery: (value, builder, filter) => {
    if (value && value.length) {
      const isSideB = filter.id.indexOf('b.') === 0;
      const whereKey = isSideB ? 'whereB' : 'where';
      const values = isArray(value) ? value : [value];
      const conditions = [];

      // AUTHORIZED should show only authorized but NOT captured
      // (captured orders are also authorized, but should show under CAPTURED)
      const authorizedConditions = [
        {
          'payment.checkoutAuthorized': true,
          'payment.checkoutCaptured': { NE: true },
        },
        {
          'payment.paymobAuthorized': true,
          'payment.paymobCaptured': { NE: true },
        },
        {
          'payment.stripeAuthorized': true,
          'payment.stripeCaptured': { NE: true },
        },
        {
          'payment.paytabsAuthorized': true,
          'payment.paytabsCaptured': { NE: true },
        },
        {
          'payment.authorized': true, // TABBY/TAMARA
          'payment.captured': { NE: true },
        },
      ];

      const capturedConditions = [
        { 'payment.checkoutCaptured': true },
        { 'payment.paymobCaptured': true },
        { 'payment.stripeCaptured': true },
        { 'payment.paytabsCaptured': true },
        { 'payment.captured': true }, // TABBY/TAMARA
      ];

      const voidedConditions = [
        { 'payment.checkoutVoided': true },
        { 'payment.paymobVoided': true },
        { 'payment.stripeVoided': true },
        // PayTabs and TABBY/TAMARA don't have voided field
      ];

      const refundedConditions = [
        { 'payment.checkoutRefunded': true },
        { 'payment.paymobRefunded': true },
        { 'payment.stripeRefunded': true },
        { 'payment.paytabsRefunded': true },
        { 'payment.refunded': true }, // TABBY/TAMARA
      ];

      values.forEach((status) => {
        if (status === 'AUTHORIZED') {
          conditions.push(...authorizedConditions);
        } else if (status === 'CAPTURED') {
          conditions.push(...capturedConditions);
        } else if (status === 'VOIDED') {
          conditions.push(...voidedConditions);
        } else if (status === 'REFUNDED') {
          conditions.push(...refundedConditions);
        }
      });

      if (conditions.length) {
        builder.add(whereKey, { OR: conditions });
      }
    }
  },
  getValueForField: getValueForFieldDefault,
  field: ['FieldSelect', {
    name: 'paymentstatus',
    placeholder: 'Payment Status',
    mode: 'multiple',
    allowClear: true,
    choices: Types.New_PAYMENT_STATUSES_ARR.map(status => ({
      label: status.charAt(0).toUpperCase() + status.slice(1).toLowerCase(),
      value: status,
    })),
  }],
}];

export const filterStore = ['FilterField', {
  id: 'store',
  label: null,
  section: 'top',
  propsFromPage: props => ({ client: props.client }),
  buildQuery: (value, builder, filter) => {
    if (value && value.length) {
      const isSideB = filter.id.indexOf('b.') === 0
      const whereKey = isSideB ? 'whereB' : 'where';
      builder.add(
        whereKey,
        { store: { IN: isArray(value) ? value : [value] } },
      );
    }
  },
  getValueForField: getValueForFieldDefault,
  field: ['FieldConnectionSelect', {
    name: 'store',
    url: '/stores/list',
    placeholder: 'Stores',
    mode: 'multiple',
    allowClear: true,
    searchPaths: ['name'],
    // getChoiceLabel: choice => `${(choice.data.name)}`,
  }],
}];

export const filterStoreStatisticsCustom = ['FilterField', {
  id: 'store',
  label: null,
  section: 'top',
  propsFromPage: props => ({ client: props.client }),
  buildQuery: (value, builder, filter) => {
    if (value && value.length) {
      const isSideB = filter.id.indexOf('b.') === 0
      // const builderKey = isSideB ? 'whereB' : 'where';
      const builderKey = isSideB ? 'customB' : 'custom';
      builder.add(
        builderKey,
        { stores: isArray(value) ? value : [value] },
      );
    }
  },
  skip: [
    viewerIsNotAdmin,
  ],
  getValueForField: getValueForFieldDefault,
  field: ['FieldConnectionSelect', {
    name: 'store',
    url: '/stores/list',
    placeholder: 'Stores',
    mode: 'multiple',
    allowClear: true,
    searchPaths: ['name'],
    // getChoiceLabel: choice => `${(choice.data.name)}`,
  }],
}];

export const filterDiscountCode = ['FilterField', {
  id: 'discountcode',
  label: null,
  section: 'top',
  propsFromPage: props => ({ client: props.client, location: props.location }),
  buildQuery: (value, builder) => value && value.length && builder.add(
    'where',
    { discountCode: { IN: isArray(value) ? value : [value] } },
  ),
  getValueForField: getValueForFieldDefault,
  field: ['FieldConnectionSelect', {
    name: 'discountcodes',
    url: '/discountcodes',
    placeholder: 'Discount Codes',
    mode: 'multiple',
    allowClear: true,
    searchPaths: ['name', 'code'],
    getExtraQueryConditions: (props) => {
      const { store } = parseQuery(props?.location?.search);
      return store
        ? [{ store }]
        : [];
    },
    // getChoiceLabel: choice => (
    //   <DiscountNameAndCode
    //     name={choice.data.name}
    //     code={choice.data.code}
    //   />
    // ),
  }],
}];

export const filterShippingCompany = ['FilterField', {
  id: 'shippingcompanies',
  label: null,
  section: 'top',
  propsFromPage: props => ({ client: props.client }),
  buildQuery: (value, builder) => value && value.length && builder.add(
    'where',
    { 'shipping.company': { IN: isArray(value) ? value : [value] } },
  ),
  getValueForField: getValueForFieldDefault,
  field: ['FieldConnectionSelect', {
    name: 'shippingcompanies',
    url: '/shippingcompanies',
    placeholder: 'Shipping Companies',
    mode: 'multiple',
    allowClear: true,
    searchPaths: ['name'],
    // getChoiceLabel: choice => `${(choice.data.name)}`,
  }],
}];

export const filterShippingCompanyName = ['FilterField', {
  id: 'shippingcompanyname',
  label: null,
  section: 'top',
  buildQuery: (value, builder) => value && builder.add(
    'where',
    { 'shipping.companyName': { REGEX: value, OPTIONS: 'i' } },
  ),
  getValueForField: value => value || '',
  getValueForQuery: (value) => {
    value = !value
      ? undefined
      : value.target
        ? value.target.value
        : value;
    return !value || !value.length
      ? undefined
      : value;
  },
  field: ['FieldText', {
    name: 'shippingcompanyname',
    label: null,
    placeholder: 'Shipping Company Name',
    allowClear: true,
  }],
}];

export const filterDateType = ['FilterField', {
  id: 'date',
  label: null,
  section: 'top',
  buildQuery: (value, builder) => {
    builder.add('custom', {
      useDate: (
        value === 'completed'
          ? 'completedAt'
          : value === 'approved'
            ? 'approvedAt'
            : value === 'shipped'
              ? 'shippedAt'
              : 'createdAt'
      ),
    });
    if (value === 'delivered') {
      // builder.add('where', { status: 'DELIVERED' });
    }
  },
  getValueForField: value => (
    value && value.length
      ? value
      : 'created'
  ),
  field: ['FieldRadio', {
    name: 'date',
    label: null,
    initialValue: 'created',
    choices: [{
      label: 'Created',
      value: 'created',
    }, {
      label: 'Approved',
      value: 'approved',
    }, {
      label: 'Shipped',
      value: 'shipped',
    }, {
      label: 'Completed',
      value: 'completed',
    }],
    Component: RadioComponent,
  }],
}];

export const filterPeriodRangeSeller = ['FilterField', {
  id: 'periodRange',
  label: null,
  section: 'top',
  placeholder: ['From Date', 'To Date'],
  propsFromPage: props => ({
    searchParams: props.searchParams,
    history: props.history,
  }),
  ranges: {
    ...[
      ['Today', 0],
      ['Last 7 Days', 7],
      ['Last 30 Days', 30],
      ['Last 60 Days', 60],
      ['Last 90 Days', 90],
      ['Last 180 Days', 180],
    ].reduce(
      (agr, [label, daysOffset = null]) => {
        agr[label] = () => {
          const now = moment();
          return [
            now.clone().subtract(Math.max(0, daysOffset - 1), 'days'),
            now,
          ];
        };
        return agr;
      },
      {},
    ),
    ...[
      ['Week', 'week'],
      ['Month', 'month'],
      ['Year', 'year'],
    ].reduce(
      (agr, [label, value]) => {
        agr[`This ${label}`] = [
          moment().startOf(value),
          moment().endOf(value),
        ];
        agr[`Past ${label}`] = [
          moment().subtract(1, value).startOf(value),
          moment().subtract(1, value).endOf(value),
        ];
        agr[`2 ${label}s Ago`] = [
          moment().subtract(2, value).startOf(value),
          moment().subtract(2, value).endOf(value),
        ];
        return agr;
      },
      {},
    ),
  },
  buildQuery: (value, builder, filter, _2, { pageProps }) => {
    const now = moment();
    const startOf2020 = moment('2020-01-01T00:00:00');
    const isSideB = filter.id.indexOf('b.') === 0
    const whereKey = isSideB ? 'whereB' : 'where';
    const dateKeyRaw = (
      isSideB
        ? pageProps.searchParams.b?.date
        : pageProps.searchParams.date
    );
    const dateKey = (
      dateKeyRaw === 'completed'
        ? 'completedAt'
        : dateKeyRaw === 'approved'
          ? 'approvedAt'
          : dateKeyRaw === 'shipped'
            ? 'shippedAt'
            : 'createdAt'
    );
    if (
      value
      && value.length
    ) {
      const values = (
        value
          .split(',')
          .map(dateString => (
            moment(dateString, 'YYYY-MM-DD')
            // .hour(now.hour())
            // .minute(now.minute())
            // .second(now.second())
            // .millisecond(now.millisecond())
          ))
      );
      if (
        values.length === 2
        && values[0] && values[0].isValid()
        && values[1] && values[1].isValid()
      ) {
        builder.add(
          whereKey,
          {
            [dateKey]: {
              GTE: values[0].startOf('day').toJSON(),
              LTE: values[1].endOf('day').toJSON(),
            },
          },
        );
        return;
      }
    }
    builder.add(
      whereKey,
      {
        [dateKey]: {
          GTE: (
            filter.defaultDateFrom
              ? moment(filter.defaultDateFrom).toJSON()
              : startOf2020.clone().startOf('month').toJSON()
          ),
          LTE: (
            filter.defaultDateTo
              ? moment(filter.defaultDateTo).toJSON()
              : now.endOf('day').toJSON()
          ),
        },
      },
    );
  },
  getValueForField: (value, props) => {
    const now = moment();
    const startOf2020 = moment('2020-01-01T00:00:00');
    if (value && value.length) {
      const values = (
        value
          .split(',')
          .map(dateString => (
            moment(dateString, 'YYYY-MM-DD')
              .hour(now.hour())
              .minute(now.minute())
              .second(now.second())
              .millisecond(now.millisecond())
          ))
      );
      if (
        values.length === 2
        && values[0] && values[0].isValid()
        && values[1] && values[1].isValid()
      ) {
        return values;
      }
    }
    return [
      (
        props.defaultDateFrom
          ? moment(props.defaultDateFrom)
          : startOf2020.clone()
      ),
      (
        props.defaultDateTo
          ? moment(props.defaultDateTo)
          : now.startOf('day')
      ),
    ];
  },
  getValueForQuery: (value) => {
    if (
      Array.isArray(value)
      && value.length === 2
      && value[0] && value[0].isValid()
      && value[1] && value[1].isValid()
    ) {
      // const now = moment();
      return `${value[0].format('YYYY-MM-DD')
        },${value[1].format('YYYY-MM-DD')
        }`;
    }
    return undefined;
  },
  // skip: [
  //   props => props.searchParams['period-span'] !== 'custom',
  // ],
  field: ['FieldDateRangePicker', {
    id: 'periodRange',
    name: 'periodRage',
    format: 'll',
    showToday: false,
    separator: '-',
    // skip: [
    //   props => props.searchParams?.['period-span'] !== 'custom',
    // ],
  }],
}];
export const filterPeriodRange = ['FilterField', {
  id: 'periodRange',
  label: null,
  section: 'top',
  placeholder: ['From Date', 'To Date'],
  propsFromPage: props => ({
    searchParams: props.searchParams,
    history: props.history,
  }),
  ranges: {
    ...[
      ['Today', 0],
      ['Last 7 Days', 7],
      ['Last 30 Days', 30],
      ['Last 60 Days', 60],
      ['Last 90 Days', 90],
      ['Last 180 Days', 180],
    ].reduce(
      (agr, [label, daysOffset = null]) => {
        agr[label] = () => {
          const now = moment();
          return [
            now.clone().subtract(Math.max(0, daysOffset - 1), 'days'),
            now,
          ];
        };
        return agr;
      },
      {},
    ),
    ...[
      ['Week', 'week'],
      ['Month', 'month'],
      ['Year', 'year'],
    ].reduce(
      (agr, [label, value]) => {
        agr[`This ${label}`] = [
          moment().startOf(value),
          moment().endOf(value),
        ];
        agr[`Past ${label}`] = [
          moment().subtract(1, value).startOf(value),
          moment().subtract(1, value).endOf(value),
        ];
        agr[`2 ${label}s Ago`] = [
          moment().subtract(2, value).startOf(value),
          moment().subtract(2, value).endOf(value),
        ];
        return agr;
      },
      {},
    ),
  },
  buildQuery: (value, builder, filter, _2, { pageProps }) => {
    const now = moment();
    const isSideB = filter.id.indexOf('b.') === 0
    const whereKey = isSideB ? 'whereB' : 'where';
    const dateKeyRaw = (
      isSideB
        ? pageProps.searchParams.b?.date
        : pageProps.searchParams.date
    );
    const dateKey = (
      dateKeyRaw === 'completed'
        ? 'completedAt'
        : dateKeyRaw === 'approved'
          ? 'approvedAt'
          : dateKeyRaw === 'shipped'
            ? 'shippedAt'
            : 'createdAt'
    );
    if (
      value
      && value.length
    ) {
      const values = (
        value
          .split(',')
          .map(dateString => (
            moment(dateString, 'YYYY-MM-DD')
            // .hour(now.hour())
            // .minute(now.minute())
            // .second(now.second())
            // .millisecond(now.millisecond())
          ))
      );
      if (
        values.length === 2
        && values[0] && values[0].isValid()
        && values[1] && values[1].isValid()
      ) {
        builder.add(
          whereKey,
          {
            [dateKey]: {
              GTE: values[0].startOf('day').toJSON(),
              LTE: values[1].endOf('day').toJSON(),
            },
          },
        );
        return;
      }
    }
    builder.add(
      whereKey,
      {
        [dateKey]: {
          GTE: (
            filter.defaultDateFrom
              ? moment(filter.defaultDateFrom).toJSON()
              : now.clone().startOf('month').toJSON()
          ),
          LTE: (
            filter.defaultDateTo
              ? moment(filter.defaultDateTo).toJSON()
              : now.endOf('day').toJSON()
          ),
        },
      },
    );
  },
  getValueForField: (value, props) => {
    const now = moment();
    if (value && value.length) {
      const values = (
        value
          .split(',')
          .map(dateString => (
            moment(dateString, 'YYYY-MM-DD')
              .hour(now.hour())
              .minute(now.minute())
              .second(now.second())
              .millisecond(now.millisecond())
          ))
      );
      if (
        values.length === 2
        && values[0] && values[0].isValid()
        && values[1] && values[1].isValid()
      ) {
        return values;
      }
    }
    return [
      (
        props.defaultDateFrom
          ? moment(props.defaultDateFrom)
          : now.clone().startOf('month')
      ),
      (
        props.defaultDateTo
          ? moment(props.defaultDateTo)
          : now.startOf('day')
      ),
    ];
  },
  getValueForQuery: (value) => {
    if (
      Array.isArray(value)
      && value.length === 2
      && value[0] && value[0].isValid()
      && value[1] && value[1].isValid()
    ) {
      // const now = moment();
      return `${value[0].format('YYYY-MM-DD')
        },${value[1].format('YYYY-MM-DD')
        }`;
    }
    return undefined;
  },
  // skip: [
  //   props => props.searchParams['period-span'] !== 'custom',
  // ],
  field: ['FieldDateRangePicker', {
    id: 'periodRange',
    name: 'periodRage',
    format: 'll',
    showToday: false,
    separator: '-',
    // skip: [
    //   props => props.searchParams?.['period-span'] !== 'custom',
    // ],
  }],
}];

export const [filterAbove, filterUnder] = [
  ['above', 'Amount more than', 'GTE'],
  ['under', 'Amount less than', 'LTE'],
].map(([id, placeholder, operator]) => [
  'FilterField', {
    id,
    label: null,
    section: 'top',
    buildQuery: (value, builder, filter) => {
      if (value) {
        const isSideB = filter.id.indexOf('b.') === 0
        const whereKey = isSideB ? 'whereB' : 'where';
        builder.add(
          whereKey,
          { 'cost.charged': { [operator]: parseFloat(value, 10) || 0 } },
        );
      }
    },
    getValueForField: value => value || '',
    getValueForQuery: value => (
      !value
        ? undefined
        : value.target
          ? value.target.value
          : value
    ),
    field: ['FieldText', {
      name: id,
      placeholder,
      addonBefore: renderCurrency(),
      style: { textAlign: 'right' },
      textAlign: 'right',
      align: 'right',
    }],
  },
]);

export const [
  filterGenerateReportStores,
  filterGenerateReportFull,
  filterGenerateProductReport,

  filterShippingCompanyExport,
] = [
  ['generate-report-stores', 'Stores Report', 'report/stores', {
    skip: [tests.viewerIsAdminAndDoesNotHavePermission('reportsExport')],
  }],
  ['generate-report-full', 'Full Report', 'report/full', {
    skip: [tests.viewerIsAdminAndDoesNotHavePermission('reportsExport')],
  }],
  ['generate-product-report', 'Products Report', 'report/products', {
    skip: [tests.viewerIsAdminAndDoesNotHavePermission('reportsExport')],
    disabled: [props => (
      props.viewer?.role === 'ADMIN'
      && (
        !props?.searchParams?.store
        || isArray(props?.searchParams?.store)
      )
    )],
  }],
  [
    'shipping-company-export',
    'Shipping Company Export',
    'shipping-company-export',
    {
      // propsFromPage: props => ({ viewer: props.viewer }),
      disabled: [({ viewer }) => (
        viewer?.role !== 'ADMIN'
        && viewer.store === '666ab14612d63500273761b0'
        && viewer.email !== 'aliona@packman.app'
      )],
      skip: [
        tests.viewerIsAdminAndDoesNotHavePermission('shippingImportExport'),
      ],
      // eslint-disable-next-line no-unused-vars
      popconfirm: (props, action) => ({
        title: (
          <div>
            <AntdRadio.Group
              id="shipping-company-export-mode"
              defaultValue="export"
              size="small"
            >
              <AntdRadio.Button value="export">
                Export
              </AntdRadio.Button>
              <AntdRadio.Button value="test">
                Test (Download Only)
              </AntdRadio.Button>
            </AntdRadio.Group>
          </div>
        ),
        destroyTooltipOnHide: true,
      }),
    },
    () => {
      // eslint-disable-next-line max-len
      const input = document.querySelector('#shipping-company-export-mode .ant-radio-button-checked input');
      const test = `${input.value}` === 'test';
      return { test };
    },
  ],
].map(([
  id,
  title,
  path,
  fieldConfig = {},
  getQueryProps = () => ({}),
]) => (['FilterField', {
  id,
  name: id,
  label: null,
  section: 'top',
  buildQuery: () => { },
  // eslint-disable-next-line max-len
  propsFromPage: ({
    client, queryBuilder, restBaseServer, searchParams, viewer,
  }) => ({
    client,
    queryBuilder,
    restBaseServer,
    searchParams,
    viewer,
  }),
  field: ['Action', {
    name: id,
    title,
    icon: 'download',
    type: 'default',
    style: { width: '100%' },
    onClick: (props) => clickAnchor({
      url: `${props.restBaseServer}/orders/${path}`,
      query: {
        access_token: props.client.getAccessToken(),
        query: props.queryBuilder.compile(),
        systemCountry: props.searchParams.sc,
        store: props.searchParams.store,
        timezone: moment.tz.guess(),
        ...getQueryProps(),
      },
    }),
    ...fieldConfig,
  }],
}]));

// export const filterShippingExported = ['FilterField', {
//   id: 'shipping-exported',
//   label: null,
//   section: 'top',
//   VALUES_MAP: {
//     any: { },
//     true: { shippingExported: true },
//     false: { shippingExported: false },
//   },
//   buildQuery: (value, builder, filter) => (
//     filter.VALUES_MAP[value]
//     ? builder.add('custom', { ...filter.VALUES_MAP[value] })
//     : builder.add('custom', { ...filter.VALUES_MAP.any })
//   ),
//   getValueForField: getValueForFieldDefault,
//   field: ['FieldSelect', {
//     name: 'shipping-exported',
//     placeholder: 'Shipping Exported Status',
//     defaultValue: 'any',
//     initialValue: 'any',
//     prepareValueForInput: value => (value ? value : null),
//     allowClear: true,
//     choices: [{
//       label: 'Any Shipping Exported Status',
//       value: null,
//     }, {
//       label: 'Shipping Already Exported',
//       value: 'true',
//     }, {
//       label: 'Shipping Not Exported Yet',
//       value: 'false',
//     }],
//   }],
// }];

export const ADMIN = [
  ...[
    [filterType, 24],

    ...[
      [filterIds, 12],
      [filterSortIds, 12],
    ].map(([filterConfig, ...filterArgs]) => ([
      [filterConfig[0], {
        ...filterConfig[1],
        skip: [
          props => props.searchParams.filter !== 'ids',
          ...(filterConfig[1].skip || []),
        ],
      }],
      ...filterArgs,
    ])),

    ...[
      [filterId, 8],
      [filterStatus, 8],
      [filterSort, 8],

      [filterStore, 12],
      [filterStorage, 12],
      [filterDateType, 24],
      [filterPeriodRange, 24],

      [filterShipping, 8, true],
      [filterPayment, 8, true],
      [filterProvider, 8, true],
      [filterPaymentStatus, 8, true],

      [filterDiscountCode, 8, true],
      [filterShippingCountry, 8, true],
      [filterShippingCompany, 8, true],
      [filterShippingCompanyName, 8, true],
      [filterAbove, 8, true],
      [filterUnder, 8, true],

      // [filterShippingExported, 24, true],
    ].map(([filterConfig, ...filterArgs]) => ([
      [filterConfig[0], {
        ...filterConfig[1],
        skip: [
          props => props.searchParams.filter === 'ids',
          ...(filterConfig[1].skip || []),
        ],
      }],
      ...filterArgs,
    ])),

    [filterGenerateReportFull, 8, true],
    [filterGenerateReportStores, 8, true],
    [filterGenerateProductReport, 8, true],

    [filterShippingCompanyExport, 12, true],
    [filterShippingCompanyImport, 12, true],
  ].map(args => getFilterWithCol(...args)),

  pagination,
  populateStore,
  scopeToListableOrders,
];

export const STATISTITS_STORES = [
  ...[
    [filterPeriodRange, 24],
    [filterShippingCountry, 24],

    [filterShipping, 12],
    [filterPayment, 12],
    [filterProvider, 12],

    [filterAbove, 12],
    [filterUnder, 12],
  ].map(args => getFilterWithCol(...args)),
];

export const STATISTICS_ORDERS = [
  ...[
    // TODO Turn into custom query prop and check on backend, only allow if no store for certain admins
    [filterStoreStatisticsCustom, 24],

    [filterPeriodRange, 24],
    [filterShippingCountry, 24],

    [filterShipping, 12],
    [filterPayment, 12],
    [filterProvider, 12],

    [filterAbove, 12],
    [filterUnder, 12],
  ].map(args => getFilterWithCol(...args)),
];

export const STATISTICS_SALES = [
  ...[
    // TODO Turn into custom query prop and check on backend, only allow if no store for certain admins
    [filterStoreStatisticsCustom, 24],
    [filterShippingCountry, 24],

    [filterShipping, 12],
    [filterPayment, 12],

    [filterAbove, 12],
    [filterUnder, 12],
  ].map(args => getFilterWithCol(...args)),
];

export const ADMIN_APPROVAL = [
  ...[
    [filterStorageRadio, 24],
    [filterId, 8],
    [filterStore, 8],
    [filterSort, 8],

    [filterPayment, 12, true],
    [filterProvider, 12, true],
    [filterShipping, 12, true],
    // [filterStorage, 8, true],

    [filterAbove, 12, true],
    [filterUnder, 12, true],
  ].map(args => getFilterWithCol(...args)),

  populateStore,
  limitTo50,
  scopeToPendingApprovalOrders,
];

export const SELLER = [
  ...[
    [filterType, 24],

    ...[
      [filterIds, 12],
      [filterSortIds, 12],
    ].map(([filterConfig, ...filterArgs]) => ([
      [filterConfig[0], {
        ...filterConfig[1],
        skip: [
          props => props.searchParams.filter !== 'ids',
          ...(filterConfig[1].skip || []),
        ],
      }],
      ...filterArgs,
    ])),

    ...[
      [filterId, 8],
      [filterStatusSeller, 8],
      [filterSort, 8],

      [filterDateType, 24],
      [filterPeriodRangeSeller, 24],

      [filterShipping, 12, true],
      [filterPayment, 12, true],
      [filterPaymentStatus, 12, true],

      [filterShippingCompany, 12, true],
      [filterDiscountCode, 12, true],

      [filterAbove, 12, true],
      [filterUnder, 12, true],

      [filterShippingCompanyExport, 12, true],
      [filterShippingCompanyImport, 12, true],

      [
        [
          filterGenerateReportFull[0],
          {
            ...filterGenerateReportFull[1],
            field: [
              filterGenerateReportFull[1].field[0],
              {
                ...filterGenerateReportFull[1].field[1],
                title: 'Orders Report',
              },
            ],
          },
        ],
        12,
        true,
      ],
      [filterGenerateProductReport, 12, true],
    ].map(([filterConfig, ...filterArgs]) => ([
      [filterConfig[0], {
        ...filterConfig[1],
        skip: [
          props => props.searchParams.filter === 'ids',
          ...(filterConfig[1].skip || []),
        ],
      }],
      ...filterArgs,
    ])),
  ].map(args => getFilterWithCol(...args)),

  pagination,
  populateStore,
  scopeToListableOrdersForSeller,
];

export const SELLER_APPROVAL = [
  ...[
    [filterId, 12],
    [filterSort, 12],

    [filterShipping, 12, true],
    [filterPayment, 12, true],

    [filterAbove, 12, true],
    [filterUnder, 12, true],
  ].map(args => getFilterWithCol(...args)),

  populateStore,
  limitTo50,
  scopeToPendingApprovalOrders,
  scopeToShippingStorageNotWarehouseOrders,
];
